// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

/**
 * Known values for Search Audience
 */
export enum KnownSearchAudience {
  /**
   * Audience for Azure China
   */
  AzureChina = "https://search.azure.cn",
  /**
   * Audience for Azure Government
   */
  AzureGovernment = "https://search.azure.us",
  /**
   * Audience for Azure Public
   */
  AzurePublicCloud = "https://search.azure.com",
}
